<template>
  <div>
    <h3 class="title text-user-secondary">Progress</h3>
    <ul>
      <li v-for="(day, index) in TASKS_BY_DAY.keys()" :key="index">
        <img
          :src="`${baseURL}/storage/media/pcs/parks/day-${day + 1}.svg`"
          alt="day"
          class="day"
        />
        <span
          v-for="(task, index) in TASKS_BY_DAY.get(day)"
          class="task"
          :key="index"
        >
          <img
            :src="`${baseURL}/storage/media/pcs/parks/${
              task.completion_time ? `complete.svg` : `incomplete.svg`
            }`"
            alt="complete"
          />
        </span>
      </li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  props: ['TASKS_BY_DAY'],

  computed: {
    baseURL: function () {
      return process.env.MIX_BASE_URL
    },
  },
}
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin-top: 10px;
  margin-bottom: 12px;
}

.task,
.day {
  margin-right: 10px;
}
</style>